import React, { useState, useEffect, useRef } from 'react';
import Header from '../../components/Header';
import { useParams } from "react-router-dom";
import './index.css';
import api from '../../services/api_despesas';
import styles from "./styles.module.css";
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import { BsFillChatDotsFill } from "react-icons/bs";
import Swal from 'sweetalert2';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';

export default function Especialidades() {

    const [especialidades, setEspecialidades] = useState([]);
    const [selectedEspecialidade, setSelectedEspecialidade] = useState('');
    const [compartimentos, setCompartimentos] = useState([]);
    const [frotas, setFrotas] = useState([]);
    const [cenario, setCenario] = useState({});
    const [servicos, setServicos] = useState([]);
    const [modalServicosOpen, setModalServicosOpen] = useState(false);
    const [modalPrevisoesOpen, setModalPrevisoesOpen] = useState(false);
    const [selectedFrota, setSelectedFrota] = useState('');
    const [selectedCompartimento, setSelectedCompartimento] = useState('');
    const [selectedServico, setselectedServico] = useState('');
    const [qtdHoras, setQtdHoras] = useState('');
    const [intExt, setIntExt] = useState('');
    const [tipoDespesa, setTipoDespesa] = useState([]);
    const [tipoDesp, setTipoDesp] = useState('');
    const [aditivoPrevisao, setAditivoPrevisao] = useState('');
    const [valor, setValor] = useState('');
    const [despesas, setDespesas] = useState([]);
    const [selectedDespesa, setSelectedDespesa] = useState('');
    const [totalHoras, setTotalHoras] = useState(0);
    const [salvando, setSalvando] = useState(false);

    let params = useParams();

    //busca os tipos de despesa por empresa
    useEffect(() => {
        if (params.cenario && params.cenario !== '') {
            api.get(`/reforma/tipodespesa`).then(function (response) {
                if (response.data) {
                    setTipoDespesa(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });
        }
    }, []);

    //busca as especialidades que precisam de reforma por cenário
    useEffect(() => {
        if (params.cenario && params.cenario !== '') {
            api.get(`/especialidade/reforma?orc_cenarios_id=${params.cenario}&obrigatorio=true`).then(function (response) {
                if (response.data) {
                    setEspecialidades(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });
        }
    }, [params.cenario]);

    //busca os dados do cenario passado por parametro para fazer todas as validações
    useEffect(() => {
        if (params.cenario && params.cenario !== '') {
            api.get(`/cenario/id/${params.cenario}`).then(function (response) {
                if (response.data) {
                    setCenario(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });
        }

    }, [params.cenario]);

    //quando seleciona a especialidade dispara esse hook para consultar todos os compartimentos que foram parametrizados para o cenário
    useEffect(() => {
        setCompartimentos([])
        if (selectedEspecialidade !== '' && params.cenario !== '') {
            api.get(`/compartimento/previsao?orc_cenarios_id=${params.cenario}&fro_especialidade_id=${especialidades[selectedEspecialidade].id}`).then(function (response) {
                if (response.data) {
                    setCompartimentos(response.data);
                }
            }).catch(function (error) {
                // handle error
                alert(error);
                console.log(error);
            }).then(function () {
                // always executed
            });
        }
    }, [selectedEspecialidade, params.cenario]);

    //quando atualiza os serviços calcula a quantidade total de horas para fazer o rateio dos percentuais
    useEffect(() => {
        var horas = 0;
        servicos.map((servico, index) => {
            servico.previsoes.map((previsao, index) => {
                horas = horas + parseInt(previsao.qtd_horas);
                setTotalHoras(horas);
            })
        })
    }, [servicos]);


    function clickEspecialidade(index) {
        setSelectedEspecialidade(index);

        api.get(`/frota/reforma?orc_cenarios_id=${params.cenario}&fro_especialidade_id=${especialidades[index].id}`).then(function (response) {
            if (response.data) {
                setFrotas(response.data);
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });
    }

    function renderEspecialidades() {
        return (
            especialidades.map((especialidade, index) => {
                if (selectedEspecialidade === index) {
                    return (
                        <div className={styles.cardespecborder} onClick={() => clickEspecialidade(index)}>
                            {especialidade.descricao}
                        </div>
                    )
                } else {
                    return (
                        <div className={styles.cardespec} onClick={() => clickEspecialidade(index)}>
                            {especialidade.descricao}
                        </div>
                    )
                }
            })
        )

    }

    function renderCompartimentos() {
        return (
            compartimentos.map((compartimento, index) => {
                return (
                    <th>{compartimento.descricao}</th>
                )
            })
        )
    }

    function handleClickCompartimentoPrevisao(compartimento_id, frota_id) {

        setSelectedCompartimento(compartimento_id);
        setSelectedFrota(frota_id);

        setModalServicosOpen(true);


        api.get(`/servico/previsao?ref_compartimentos_id=${compartimento_id}&fro_frota_id=${frota_id}
        &orc_cenarios_id=${params.cenario}&fro_especialidade_id=${especialidades[selectedEspecialidade].id}`).then(function (response) {

            if (response.data) {
                setServicos(response.data);
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

    }

    function renderRowCompartimentos(frota) {
        const dataAtual = moment(new Date());
        const inicioCenario = moment(cenario.inicio_cenario);
        const fimCenario = moment(cenario.fim_cenario);
        const inicioPreenchimento = moment(cenario.inicio_preenchimento);
        const fimPreenchimento = moment(cenario.fim_preenchimento);

        return (
            compartimentos.map((compartimento, index) => {
                return (
                    compartimento.frotas.map((f) => {
                        var valor = 0;
                        var horas = 0;

                        //caso tenha pervisçao e despesas pega os valores totais para mostrar em tela
                        if (frota.previsao_reforma && frota.previsao_reforma.length > 0) {
                            frota.previsao_reforma.map((previsao, index) => {
                                if (previsao.ref_compartimentos_id === compartimento.id) {
                                    horas = horas + parseFloat(previsao.qtd_horas);
                                    if (previsao.despesas && previsao.despesas.length > 0) {
                                        previsao.despesas.map((despesa, index) => {
                                            valor = valor + parseFloat(despesa.valor);
                                        })
                                    }
                                }
                            })
                        }

                        if (f.id === frota.id) {

                            if (horas > 0) {

                                return (
                                    <td onClick={() => handleClickCompartimentoPrevisao(compartimento.id, frota.id)} className={styles.btnaddserv}>
                                        <div>VLR: {valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} </div>
                                        <div>HRS: {horas}</div>
                                    </td>
                                )
                            } else {
                                if ((dataAtual >= inicioCenario && dataAtual <= fimCenario) || (dataAtual >= inicioPreenchimento && dataAtual <= fimPreenchimento)) {
                                    return (
                                        <td><FaPlusCircle size="25" color='green' onClick={() => handleClickCompartimentoPrevisao(compartimento.id, frota.id)} className={styles.btnaddserv} /></td>
                                    )
                                } else {
                                    return (<td></td>)
                                }
                            }
                        }
                    })
                )
            })
        )
    }

    function renderRowPrevisao() {
        return (
            frotas.map((frota, index) => {
                return (
                    <tr>
                        <td>{frota.cod_frota}</td>
                        {renderRowCompartimentos(frota)}
                    </tr>
                )
            })
        )
    }

    function renderPrevReforma() {

        if (selectedEspecialidade !== '' && compartimentos.length > 0) {

            return (
                <div className={styles.tbfrota}>
                    <table className='table table-sm'>
                        <thead>
                            <tr>
                                <th>FROTA:</th>
                                {renderCompartimentos()}
                            </tr>
                        </thead>
                        <tbody>
                            {renderRowPrevisao()}
                        </tbody>
                    </table>
                </div>
            )
        }
    }

    function fecharModalServicos() {
        setModalServicosOpen(false);
    }

    function handleClickServico(id, index) {

        setselectedServico(id);

        if (servicos[index] && servicos[index].previsoes[0] && servicos[index].previsoes[0].id) {
            setQtdHoras(servicos[index].previsoes[0].qtd_horas);
            setIntExt(servicos[index].previsoes[0].tipo_servico);
        } else {
            setQtdHoras('');
            setIntExt('');
        }
        setDespesas([]);

        setDespesas([]);

        api.get(`/reforma/despesa?ref_servicos_id=${id}&ref_compartimentos_id=${selectedCompartimento}&fro_frota_id=${parseInt(selectedFrota)}&fro_especialidade_id=${especialidades[selectedEspecialidade].id}&orc_cenarios_id=${params.cenario}`).then(function (response) {
            if (response.data) {
                setDespesas(response.data);
            }
        }).catch(function (error) {
            // handle error
            alert(error);
            console.log(error);
        }).then(function () {
            // always executed
        });

        setModalPrevisoesOpen(true);

    }

    function renderValorServicos(servico) {
        if (servico.previsoes && servico.previsoes[0] && servico.previsoes[0].despesas) {
            var valor = 0;
            servico.previsoes[0].despesas.map((despesa, index) => {
                valor = parseFloat(despesa.valor) + valor;
            })
            return (
                <td>{valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
            )
        } else {
            return (<td></td>)
        }

    }

    function renderHorasServico(servico) {
        if (servico.previsoes && servico.previsoes[0]) {
            return (
                <td>{servico.previsoes[0].qtd_horas}</td>
            )
        } else {
            return (<td></td>)
        }
    }

    function renderTotalHorasServico(servico) {
        if (servico.previsoes && servico.previsoes[0]) {
            return (
                <td>{(servico.previsoes[0].qtd_horas / totalHoras * 100).toFixed(2)} %</td>
            )
        } else {
            return (<td></td>)
        }
    }

    function renderTipoServico(servico) {
        if (servico.previsoes && servico.previsoes[0]) {
            switch (servico.previsoes[0].tipo_servico) {
                case 1:

                    return (
                        <td>INTERNO</td>
                    )
                case 2:

                    return (
                        <td>EXTERNO</td>
                    )

                default:
                    break;
            }

        } else {
            return (<td></td>)
        }

    }

    function renderRowServicos() {
        return (
            servicos.map((servico, index) => {
                return (
                    <tr onClick={() => handleClickServico(servico.id, index)}>
                        <td><input type="checkbox" checked={(servico.previsoes[0] && servico.previsoes[0].id ? true : false)} /></td>
                        <td>{servico.descricao}</td>
                        {renderValorServicos(servico)}
                        {renderHorasServico(servico)}
                        {renderTotalHorasServico(servico)}
                        {renderTipoServico(servico)}
                    </tr>
                )
            })
        )
    }

    function renderModalServicos() {
        return (
            <div className={(modalServicosOpen ? styles.modalEsp : "modal-fechado")}>
                <span className="fechar-modal-previsoes" onClick={() => fecharModalServicos()}>x</span>
                <div>
                    <h4>SERVIÇOS</h4>
                </div>
                <table className='table table-sm'>
                    <thead>
                        <tr>
                            <th></th>
                            <th>DESCRIÇÃO</th>
                            <th>VALOR</th>
                            <th>QTD. HORAS</th>
                            <th>% HORAS</th>
                            <th>TIPO</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderRowServicos()}
                    </tbody>
                </table>
            </div>
        )
    }

    function fecharModalPrevisoes() {
        setQtdHoras('');
        setIntExt('');
        setValor('');
        setTipoDesp('');
        setAditivoPrevisao('');
        setSelectedDespesa('');
        setModalPrevisoesOpen(false);
    }

    function renderTiposDespesa() {
        return (
            tipoDespesa.map((despesa, index) => {
                if (parseInt(intExt) === 2 && despesa.codigo === 3) {
                    return (<></>)
                } else {
                    return (
                        <label className={styles.labelservico}>
                            <input type="radio" name="radiotipodesp" checked={(tipoDesp === despesa.id ? true : false)} onChange={() => setTipoDesp(despesa.id)} />
                            {despesa.descricao}
                        </label>
                    )
                }
            })
        )
    }

    function handleAddPrevisao() {

        if (!salvando) {

            if (valor === '') {
                Swal.fire('O CAMPO VALOR NÃO PODE SER EM BRANCO!');
                return;
            }
            if (aditivoPrevisao === '') {
                Swal.fire('O CAMPO ADITIVO/PREVISÃO NÃO PODE SER EM BRANCO!');
                return;
            }

            if (tipoDesp === '') {
                Swal.fire('O CAMPO TIPO DESPESA NÃO PODE SER EM BRANCO!');
                return;
            }


            setSalvando(true);
            var body = {
                valor: valor,
                aditivo_previsao: aditivoPrevisao,
                ref_tipo_despesa_id: tipoDesp,
                ref_servicos_id: selectedServico,
                ref_compartimentos_id: selectedCompartimento,
                fro_frota_id: selectedFrota,
                fro_especialidade_id: especialidades[selectedEspecialidade].id,
                orc_cenarios_id: params.cenario,
            }

            //quando insere uma previsão atualiza os serviços e também as frotas com essa previsão para renderizar em tela
            var objServ = Object.assign([], servicos);
            var selectedServ = objServ.find(s => s.id === selectedServico);

            var objFrotas = Object.assign([], frotas);
            var selFrota = objFrotas.find(f => f.id === selectedFrota);

            console.log('selected frota', selFrota)

            if (selectedDespesa !== '') {

                body.id = selectedDespesa;

                api.put(`/reforma/despesa`, body).then(function (response) {
                    if (response.data) {

                        var ObjDesp = Object.assign([], despesas);

                        var index = ObjDesp.indexOf(ObjDesp.find(d => parseInt(d.id) === parseInt(selectedDespesa)));
                        console.log('index', index)

                        ObjDesp[index].valor = valor;
                        ObjDesp[index].aditivo_previsao = aditivoPrevisao;
                        ObjDesp[index].ref_tipo_despesa_id = tipoDesp;
                        ObjDesp[index].status_aut = 1;
                        ObjDesp[index].motivo = '';

                        selFrota.previsao_reforma[0].despesas[index].valor = valor;
                        selFrota.previsao_reforma[0].despesas[index].aditivo_previsao = aditivoPrevisao;
                        selFrota.previsao_reforma[0].despesas[index].ref_tipo_despesa_id = tipoDesp;
                        selFrota.previsao_reforma[0].despesas[index].status_aut = 1;
                        selFrota.previsao_reforma[0].despesas[index].motivo = '';

                        selectedServ.previsoes[0].despesas[index].valor = valor;
                        selectedServ.previsoes[0].despesas[index].aditivo_previsao = aditivoPrevisao;
                        selectedServ.previsoes[0].despesas[index].ref_tipo_despesa_id = tipoDesp;
                        selectedServ.previsoes[0].despesas[index].status_aut = 1;
                        selectedServ.previsoes[0].despesas[index].motivo = '';


                        //atualiza todos os estados que interagem com as previsões
                        setFrotas(objFrotas);
                        setServicos(objServ);
                        setDespesas(ObjDesp);
                        setValor('');
                        setTipoDesp('');
                        setAditivoPrevisao('');
                    }
                }).catch(function (error) {
                    // handle error
                    alert(error);
                    console.log(error);
                }).then(function () {
                    // always executed
                    setSalvando(false);
                });
            } else {
                api.post(`/reforma/despesa`, body).then(function (response) {
                    if (response.data) {

                        var ObjDesp = Object.assign([], despesas);
                        ObjDesp.push(response.data);
                        if (selectedServ.previsoes[0]) {
                            if (!selectedServ.previsoes[0].despesas) {
                                selectedServ.previsoes[0].despesas = [];
                            }
                            selectedServ.previsoes[0].despesas.push(response.data);
                        }

                        if (selFrota.previsao_reforma[0]) {
                            if (!selFrota.previsao_reforma[0].despesas) {
                                selFrota.previsao_reforma[0].despesas = []
                            }
                            selFrota.previsao_reforma[0].despesas.push(response.data);
                        }

                        //atualiza todos os estados que interagem com as previsões
                        setFrotas(objFrotas);
                        setServicos(objServ);
                        setDespesas(ObjDesp);
                        setValor('');
                        setTipoDesp('');
                        setAditivoPrevisao('');
                    }
                }).catch(function (error) {
                    // handle error
                    alert(error);
                    console.log(error);
                }).then(function () {
                    // always executed
                    setSalvando(false);
                });
            }
        }
    }

    function renderStatusAutDesp(despesa) {
        var status = '';
        switch (despesa.status_aut) {

            case 1:
                status = 'AGUARDANDO GESTOR'
                break;
            case 2:
                status = 'AGUARDANDO CON/DIR'
                break;

            case 3:
                status = 'RECUSADO GESTOR'
                break;

            case 4:
                status = 'APROVADO CON/DIR'
                break;

            case 5:
                status = 'DEVOLVIDO'
                break;

            case 6:
                status = 'RECUSADO CON/DIR'
                break;


            default:
                break;
        }
        return (
            <td onClick={() => handleClickDespesa(despesa)}>{status}</td>
        )
    }

    function handleClickDespesa(despesa) {

        if (despesa.status_aut === 1 || despesa.status_aut === 5) {

            setSelectedDespesa(despesa.id);
            setValor(despesa.valor);
            setAditivoPrevisao(despesa.aditivo_previsao);
            setTipoDesp(despesa.ref_tipo_despesa_id);
        }

    }

    function handleDeleteDespesa(despesa, index) {
        if (despesa.status_aut === 1 || despesa.status_aut === 5) {
            Swal.fire({
                title: 'TEM CERTEZA QUE DESEJA APAGAR O LANÇAMENTO?',
                showDenyButton: true,
                confirmButtonText: 'SIM APAGAR',
                denyButtonText: `NÃO`,
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    var objServ = Object.assign([], servicos);
                    var selectedServ = objServ.find(s => s.id === selectedServico);

                    var objFrotas = Object.assign([], frotas);
                    var selFrota = objFrotas.find(f => f.id === selectedFrota);

                    api.delete(`/reforma/despesa/id/${despesa.id}`).then(function (response) {
                        if (response.data) {

                            var ObjDesp = Object.assign([], despesas);
                            ObjDesp.splice(index, 1);

                            //faz o mesmo processo da inserção, só que reverso, remove a despesa especifica dos objetos que interagem com ela
                            if (selFrota.previsao_reforma[0] && selFrota.previsao_reforma[0].despesas[index]) {
                                selFrota.previsao_reforma[0].despesas.splice(index, 1);
                            }

                            if (selectedServ.previsoes[0] && selectedServ.previsoes[0].despesas[index]) {
                                selectedServ.previsoes[0].despesas.splice(index, 1);
                            }

                            setFrotas(objFrotas);

                            setServicos(objServ);

                            setDespesas(ObjDesp);
                        }
                    }).catch(function (error) {
                        // handle error
                        alert(error);
                        console.log(error);
                    }).then(function () {
                        // always executed
                    });
                }
            })
        }

    }

    function renderMotivoDesp(despesa) {

        const place = "top";
        const type = "dark";
        const effect = "float";

        if (despesa.motivo && despesa.motivo !== '') {
            return (
                <td>
                    <div className="demonstration">
                        <a
                            data-for="main"
                            data-tip={despesa.motivo}
                            data-iscapture="true"
                        >
                            <BsFillChatDotsFill />
                        </a>
                    </div>
                    <ReactTooltip
                        id="main"
                        place={place}
                        type={type}
                        effect={effect}
                        multiline={true}
                    />
                </td>
            )
        } else {
            return (<td></td>)
        }
    }

    function renderDeleteDesp(despesa, index) {
        if (despesa.status_aut === 1 || despesa.status_aut === 5) {
            const dataAtual = moment(new Date());
            const inicioCenario = moment(cenario.inicio_cenario);
            const fimCenario = moment(cenario.fim_cenario);
            const inicioPreenchimento = moment(cenario.inicio_preenchimento);
            const fimPreenchimento = moment(cenario.fim_preenchimento);
            if ((dataAtual >= inicioCenario && dataAtual <= fimCenario) || (dataAtual >= inicioPreenchimento && dataAtual <= fimPreenchimento)) {
                return (
                    <td><FaMinusCircle color="red" onClick={() => handleDeleteDespesa(despesa, index)} className={styles.btndel} /></td>
                )
            } else {
                return (<td></td>)
            }
        } else {
            return (<td></td>)
        }
    }

    function renderRowDespesas() {
        return (
            despesas.map((despesa, index) => {
                return (
                    <tr className={styles.clicktbdesp}>
                        <td onClick={() => handleClickDespesa(despesa)}>{despesa.usuario_id}</td>
                        <td onClick={() => handleClickDespesa(despesa)}>{despesa.valor}</td>
                        <td onClick={() => handleClickDespesa(despesa)}>{despesa.ref_tipo_despesa_id}</td>
                        <td onClick={() => handleClickDespesa(despesa)}>{despesa.aditivo_previsao}</td>
                        {renderStatusAutDesp(despesa)}
                        {renderMotivoDesp(despesa)}
                        {renderDeleteDesp(despesa, index)}
                    </tr>
                )
            })
        )
    }

    function renderAditivo() {
        const dataAtual = moment(new Date());
        const inicioCenario = moment(cenario.inicio_cenario);
        const fimCenario = moment(cenario.fim_cenario);


        if ((dataAtual >= inicioCenario && dataAtual <= fimCenario)) {
            return (
                <label className={styles.labelservico}>
                    <input type="radio" name="radioaditivoprev" checked={(aditivoPrevisao === 'A' ? true : false)} onChange={() => setAditivoPrevisao('A')} />
                    ADITIVO
                </label>
            )

        } else {
            return (<></>)
        }
    }

    function renderPrevisao() {
        const dataAtual = moment(new Date());
        const inicioPreenchimento = moment(cenario.inicio_preenchimento);
        const fimPreenchimento = moment(cenario.fim_preenchimento);

        if ((dataAtual >= inicioPreenchimento && dataAtual <= fimPreenchimento)) {
            return (
                <label className={styles.labelservico}>
                    <input type="radio" name="radioaditivoprev" checked={(aditivoPrevisao === 'P' ? true : false)} onChange={() => setAditivoPrevisao('P')} />
                    PREVISÃO
                </label>
            )

        } else {
            return (<></>)
        }

    }

    function renderAddDespesas() {
        const dataAtual = moment(new Date());
        const inicioCenario = moment(cenario.inicio_cenario);
        const fimCenario = moment(cenario.fim_cenario);
        const inicioPreenchimento = moment(cenario.inicio_preenchimento);
        const fimPreenchimento = moment(cenario.fim_preenchimento);
        if ((dataAtual >= inicioCenario && dataAtual <= fimCenario) || (dataAtual >= inicioPreenchimento && dataAtual <= fimPreenchimento)) {
            return (
                <>
                    <div>
                        <h5>DESPESAS</h5>
                    </div>
                    <div>
                        <label>VALOR</label>
                        <input type="text" value={valor} onChange={(e) => setValor(e.target.value)} />
                    </div>
                    <div>
                        <label>TIPO DESPESA</label>
                        {renderTiposDespesa()}
                    </div>
                    <div>
                        <label>ADITIVO/PREVISAO</label>
                        {renderAditivo()}
                        {renderPrevisao()}
                    </div>
                    <FaPlusCircle size="35" color='green' className={styles.btnaddservico} onClick={() => handleAddPrevisao()} />
                </>
            )
        } else {
            return (<></>)
        }
    }

    function renderAddPrevisoes() {

        if (servicos.length > 0) {

            var objServ = Object.assign([], servicos);

            if (selectedServico !== '') {

                var selectedServ = objServ.find(f => f.id === selectedServico);

                if (selectedServ) {

                    if (selectedServ.previsoes[0] && selectedServ.previsoes[0].id) {
                        return (
                            <div className={styles.previsoes}>
                                {renderAddDespesas()}
                                <table className='table table-sm'>
                                    <thead>
                                        <tr>
                                            <th>USUARIO CAD.</th>
                                            <th>VALOR</th>
                                            <th>TIPO DESPESA</th>
                                            <th>ADITIVO/PREVISAO</th>
                                            <th>STATUS</th>
                                            <th>MOTIVO</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {renderRowDespesas()}
                                    </tbody>
                                </table>
                            </div>
                        )
                    } else {
                        return (
                            <></>
                        )
                    }
                }
            }
        }
    }

    function handleSalvarPrevisao() {

        if (!salvando) {


            if (intExt === '') {
                Swal.fire('O TIPO DO SERVIÇO DEVE SER SELECIONADO!');
                return;
            }

            if (qtdHoras === '') {
                Swal.fire('O CAMPO QUANTIDADE DE HORAS NÃO PODE FICAR EM BRANCO!');
                return;
            }

            setSalvando(true);
            const body = {
                ref_servicos_id: selectedServico,
                ref_compartimentos_id: selectedCompartimento,
                qtd_horas: qtdHoras,
                tipo_servico: intExt,
                fro_frota_id: selectedFrota,
                fro_especialidade_id: especialidades[selectedEspecialidade].id,
                orc_cenarios_id: params.cenario,
            }

            var ObjServ = Object.assign([], servicos);

            var servSel = ObjServ.find(s => s.id === selectedServico);

            var objFrotas = Object.assign([], frotas);
            var selFrota = objFrotas.find(f => f.id === selectedFrota);


            if (servSel.previsoes[0] && servSel.previsoes[0].id) {

                body.id = servSel.previsoes[0].id;

                api.put(`/reforma/previsao`, body).then(function (response) {
                    if (response.data) {

                        //adiciona a reforma nos objetos que interagem com ela, no caso frota e serviços
                        servSel.previsoes[0].qtd_horas = qtdHoras;
                        servSel.previsoes[0].tipo_servico = intExt;

                        selFrota.previsao_reforma[0].qtd_horas = qtdHoras;
                        selFrota.previsao_reforma[0].tipo_servico = intExt;

                        setFrotas(objFrotas);

                        setServicos(ObjServ);

                        Swal.fire('O REGISTRO FOI ATUALIZADO COM SUCESSO!');
                    }
                }).catch(function (error) {
                    // handle error
                    alert(error);
                    console.log(error);
                }).then(function () {
                    // always executed
                    setSalvando(false);
                });

            } else {

                api.post(`/reforma/previsao`, body).then(function (response) {
                    if (response.data) {

                        servSel.previsoes.push(response.data);

                        if (!selFrota.previsao_reforma) {
                            selFrota.previsao_reforma = []
                        }
                        selFrota.previsao_reforma.push(response.data);

                        setFrotas(objFrotas);

                        setServicos(ObjServ);

                        Swal.fire('O REGISTRO FOI SALVO COM SUCESSO!');
                    }
                }).catch(function (error) {
                    // handle error
                    alert(error);
                    console.log(error);
                }).then(function () {
                    // always executed
                    setSalvando(false);
                });

            }
        }
    }

    function handleExcluirPrevisao() {
        Swal.fire({
            title: 'TEM CERTEZA QUE DESEJA APAGAR O LANÇAMENTO?',
            showDenyButton: true,
            confirmButtonText: 'SIM APAGAR',
            denyButtonText: `NÃO`,
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                var ObjServ = Object.assign([], servicos);

                var servSel = ObjServ.find(s => s.id === selectedServico);

                var objFrotas = Object.assign([], frotas);
                var selFrota = objFrotas.find(f => f.id === selectedFrota);


                var ref_servicos_id = selectedServico;
                var ref_compartimentos_id = selectedCompartimento;
                var fro_frota_id = selectedFrota;
                var fro_especialidade_id = especialidades[selectedEspecialidade].id;
                var orc_cenarios_id = params.cenario;

                api.delete(`/reforma/previsao/${ref_servicos_id}/${ref_compartimentos_id}/${fro_frota_id}/${fro_especialidade_id}/${orc_cenarios_id}`).then(function (response) {
                    if (response.data) {

                        servSel.previsoes = [];

                        selFrota.previsao_reforma = []

                        setFrotas(objFrotas);

                        setServicos(ObjServ);

                        Swal.fire('O REGISTRO FOI APAGADO COM SUCESSO!');
                    }
                }).catch(function (error) {
                    // handle error
                    alert(error);
                    console.log(error);
                }).then(function () {
                    // always executed
                    setSalvando(false);
                });

            } else if (result.isDenied) {
                Swal.fire('Changes are not saved', '', 'info')
            }
        })
    }

    function renderExcluirPrevisao() {
        const dataAtual = moment(new Date());
        const inicioCenario = moment(cenario.inicio_cenario);
        const fimCenario = moment(cenario.fim_cenario);
        const inicioPreenchimento = moment(cenario.inicio_preenchimento);
        const fimPreenchimento = moment(cenario.fim_preenchimento);
        if ((dataAtual >= inicioCenario && dataAtual <= fimCenario) || (dataAtual >= inicioPreenchimento && dataAtual <= fimPreenchimento)) {
            return (
                <div className={styles.btntiposervico}>
                    <input type="button" className='btn btn-sm btn-danger' value="EXCLUIR" onClick={() => handleExcluirPrevisao()} />
                </div>
            )
        } else {
            <div></div>
        }
    }

    function renderSalvarPrevisao() {
        const dataAtual = moment(new Date());
        const inicioCenario = moment(cenario.inicio_cenario);
        const fimCenario = moment(cenario.fim_cenario);
        const inicioPreenchimento = moment(cenario.inicio_preenchimento);
        const fimPreenchimento = moment(cenario.fim_preenchimento);
        if ((dataAtual >= inicioCenario && dataAtual <= fimCenario) || (dataAtual >= inicioPreenchimento && dataAtual <= fimPreenchimento)) {
            return (
                <div className={styles.btntiposervico}>
                    <input type="button" className='btn btn-sm btn-success' value="SALVAR" onClick={() => handleSalvarPrevisao()} />
                </div>
            )
        } else {
            return (<div></div>)
        }
    }

    function renderAddDadosServ() {
        const dataAtual = moment(new Date());
        const inicioCenario = moment(cenario.inicio_cenario);
        const fimCenario = moment(cenario.fim_cenario);
        const inicioPreenchimento = moment(cenario.inicio_preenchimento);
        const fimPreenchimento = moment(cenario.fim_preenchimento);
        if ((dataAtual >= inicioCenario && dataAtual <= fimCenario) || (dataAtual >= inicioPreenchimento && dataAtual <= fimPreenchimento)) {
            return (
                <>
                    <div className={styles.tiposervico}>
                        <label>TIPO DO SERVIÇO</label>
                        <div>
                            <label className={styles.labelservico}>
                                <input type="radio" name="radioservico" checked={(intExt === 1 ? true : false)} onChange={() => setIntExt(1)} />
                                INTERNO
                            </label>
                            <label className={styles.labelservico}>
                                <input type="radio" name="radioservico" checked={(intExt === 2 ? true : false)} onChange={() => setIntExt(2)} />
                                EXTERNO
                            </label>
                        </div>
                    </div>
                    <div className={styles.tiposervico}>
                        <label>QTD. HORAS</label>
                        <input type="text" value={qtdHoras} onChange={(e) => setQtdHoras(e.target.value)} />
                    </div>
                </>
            )
        } else {
            return (
                <></>
            )
        }
    }

    function renderModalPrevisoes() {
        return (
            <div className={(modalPrevisoesOpen ? styles.modalEsp : "modal-fechado")}>
                <span className="fechar-modal-previsoes" onClick={() => fecharModalPrevisoes()}>x</span>
                <div>
                    <h4>PREVISAO</h4>
                </div>
                <div className={styles.servicos}>
                    {renderAddDadosServ()}
                    {renderSalvarPrevisao()}
                    {renderExcluirPrevisao()}
                </div>

                {renderAddPrevisoes()}

            </div>
        )
    }

    return (
        <>
            {renderModalServicos()}
            {renderModalPrevisoes()}
            <div className="container-lg">
                <Header title="PREVISÕES DA REFORMA" />
                <div className={styles.contentespec}>
                    {renderEspecialidades()}
                </div>
                {renderPrevReforma()}
            </div>
        </>
    )
}